import * as updateName from "@/api/users/updateName";

export default {
	namespaced: true,
	state: {
		newName: {},
		error: null,
	},
	getters: {
		readNewName: (state) => state.newName,
		readError: (state) => state.error,
	},
	mutations: {
		SET_NEW_NAME(state, payload) {
			state.newName = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async updateName({ commit, getters,rootGetters }) {
			const token = rootGetters['loginStore/readToken'];
			const updateNameRes = await updateName
				.updateName(token, getters.readNewName)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return updateNameRes;
		},
	},
};
